import { render, staticRenderFns } from "./IndagineEpidemiologicaMorbilloRosoliaEditComponent.vue?vue&type=template&id=293808d3"
import script from "./IndagineEpidemiologicaMorbilloRosoliaEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaMorbilloRosoliaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports